import {
  titleUI,
  descriptionUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { adaptiveHousingDescription } from '../../content/additionalBenefits';

export default {
  uiSchema: {
    ...titleUI('Adapted housing grants'),
    ...descriptionUI(adaptiveHousingDescription),
    'view:modifyingHome': yesNoUI(
      'Do you need help modifying or buying your home?',
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:modifyingHome': { type: 'boolean' },
    },
  },
};
